import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDelete = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	width: 24,
	height: 24,
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.43335 19.6333C7.00113 19.6333 6.63196 19.4803 6.32585 19.1741C6.01973 18.868 5.86667 18.4989 5.86667 18.0666V7.06664H5V5.76666H8.89999V5H14.1V5.76666H18V7.06664H17.1333V18.0666C17.1333 18.5044 16.9817 18.875 16.6783 19.1783C16.375 19.4817 16.0044 19.6333 15.5667 19.6333H7.43335ZM15.8333 7.06664H7.16665V18.0666C7.16665 18.1444 7.19166 18.2083 7.24166 18.2583C7.29167 18.3083 7.35556 18.3333 7.43335 18.3333H15.5667C15.6333 18.3333 15.6944 18.3056 15.75 18.25C15.8056 18.1944 15.8333 18.1333 15.8333 18.0666V7.06664ZM9.25002 16.6H10.55V8.79998H9.25002V16.6ZM12.45 16.6H13.75V8.79998H12.45V16.6Z",
		fill: "currentColor"
	})
});
export default SvgDelete;
